import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';


// DEFAULT COMPONENT
const UniModalPortableContainer = (props) => {
  const ComponentModal = props.ComponentModal;
  const {
    uniModalPortableContent,
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.uniModalPortableContainerPack;

  let containerOptions = props.options; // TODO

  let options = {};
  // if (js_utils.is_object(props.options)) {
  if (js_utils.is_object(uniModalPortableContent?.options)) {
    options = uniModalPortableContent.options;
  }

  /*
  if (modal.modalContent !== false) {
    jsx = (
      <div className={'unicompo-modal-bottom-sheet-koglovo__overlay'}>
        <div className="modal-scrollable">
          <div className="fix-center-flex">
            <div className="flex-1"></div>

            <div className="modal">
              {
                without_x_button !== true && (
                  <>
                    <div className="modal-close" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                    <div className="modal-close modal-close--left" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                  </>
                )
              }
              {
                reloading === false ? (modal.modalContent) : (jsxTempReloading)
              }
            </div>

            <div className="flex-1"></div>
          </div>
        </div>
      </div>
    );
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
  */

  /*
  let jsxModalContent = null;
  if (props.children !== false) {
    jsxModalContent = props.children;
  }
  */

  /*
  return (
    <ComponentModal
      opened={props.opened}
      cbClose={props.cbClose}
      options={options}
    >{(props.children !== false && props.children) ? (props.children) : (null)}</ComponentModal>
  );
  */
  return (
    <ComponentModal
      opened={uniModalPortableContent !== false}
      cbClose={setUniModalPortableClose}
      options={options}
    >{
        uniModalPortableContent && uniModalPortableContent.jsx ? (uniModalPortableContent.jsx) : (null)
      }</ComponentModal>
  );
};

export default UniModalPortableContainer;